import { SelectItem } from "primeng/api";
import { FormControl } from "@angular/forms";

export class Constants {
	public static AssemblyVersionKey: string = "assembly_version";

	public static USER_AVATAR_KEY: string = "user_avatar";
	public static TIME_ZONES_KEY: string = "allTimeZones";
	public static STATES_KEY: string = "allStates";

	public static DEFAULT_FORMAT_DATETIME = "DD-MMM-YYYY HH:mm";
	public static DEFAULT_FORMAT_DATE = "DD-MMM-YYYY";
	public static DEFAULT_FORMAT_TIME = "hh:mm A";
	public static DEFAULT_LOCALE = "en";
	public static DEFAULT_TIMEZONE = "America/Santa_Isabel";

	public static REFERENCE_TYPE_ID = "REFERENCE_ENTITY";

	public static ROWS_PER_PAGE_OPTIONS = [15, 25, 50, 100, 250];
	public static ROWS_PER_PAGE_OPTIONS_SUB_GRIDS = [5, 10, 15, 20];

	public static DIVISION_EVENTS_ID = "d045d632-07bd-4d6b-a123-b046f37d14c3";

	public static GUID_EMPTY = "00000000-0000-0000-0000-000000000000";

	public static NOT_SET = "Not Set";

	public static emailRegx: string = "[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}";
	public static phoneRegx: RegExp = /(\+)?((\d+)|(\d+\-)|(\(\d+\))|(\(\d+\)\-))*(\d+)/;
	public static positiveDecimalRegx: RegExp = /^[+]?([1-9][0-9]*(?:[\.][0-9]*)?|0*\.0*[1-9][0-9]*)(?:[eE][+-][0-9]+)?$/;
	public static excludeZero: RegExp = /[1 - 9]\d*$/;
	public static wholeNumberRegx: RegExp = /^\d*$/;
	public static currencyRegx: RegExp = /^\d*\.?(\d*)?$/;

	public static MILE_TO_METERS_RATIO: number = 1609.344;
	public static METERS_TO_MILE_RATIO: number = 0.000621;
	public static BOOLEAN_TRUE = "true";
	public static BOOLEAN_FALSE = "false";
	public static NULL = "null";

	public static KILOMETER_TO_METERS_RATIO: number = 1000.0;
	public static METERS_TO_KILOMETER_RATIO: number = 0.001;
	public static MAX_LOCATION_REQUESTS: number = 5;
	public static CUSTOM_MAP_MARKER_ICON_RELATIVE_PATH: string = "/assets/images/hub_map-icon_16x16_red.png";
	public static CUSTOM_MAP_MARKER_ICON_ACTIVE_RELATIVE_PATH: string = "/assets/images/hub_map-icon_16x16_blue.png";
	
	// TODO: What is this?     
	public static CURRENCY_SYMBOL_DOLLAR: string = '$';

	// Grid Settings
	public static readonly MAIN_GRID_PAGE_SIZE = 25;
	public static readonly SUB_GRID_PAGE_SIZE = 15;
	public static readonly COLUMN_MINIMUM_WIDTH = 150;

	// number pattern
	public static readonly inputNumber = "\d+(\.\d{1,2})?";
	public static readonly inputPercent = "^0*(?:[1-9][0-9]?|100)$|^0*$";

	public static readonly saveConfirmationMessage = "You haven't saved your changes.<br>Going back will lose your changes.";
	public static readonly saveConfirmationHeader = "Are You Sure?";

	public static readonly nullItem: SelectItem[] = [{ value: null, label: '- Select -' }];

	public static notObject(fc: FormControl) {
		var isDictionary = typeof fc.value;

		if (isDictionary != 'object') {
			return ({ notObject: true });
		} else {
			return (null);
		}
	}

	public static getSeasonStartDate(date: Date = null): Date {
		var currentDate = date || new Date();
		var seasonStartDate = new Date(new Date(currentDate.getFullYear() + '-' + '09' + '-' + '01').setHours(0,0,0,0)); 
		if(seasonStartDate > currentDate)
        {
            return new Date(new Date(seasonStartDate.setFullYear(currentDate.getFullYear() - 1)).setHours(0,0,0,0));
		}
		return seasonStartDate;
	}

	public static getSeasonEndDate(date: Date = null): Date {
		var currentDate = date || new Date();
		var seasonEndDate = new Date(new Date(currentDate.getFullYear() + '-' + '08' + '-' + '31').setHours(0,0,0,0)); 
		if(seasonEndDate < currentDate)
        {
            return new Date(new Date(seasonEndDate.setFullYear(currentDate.getFullYear() + 1)).setHours(0,0,0,0));
		}
		return seasonEndDate;
	}
}
